import { mapState, mapActions } from 'vuex';
import { can } from '../utils/rights';

export default {
  props: {
    // Base rights group name
    rightsGroup: String,

    // Should the create/new button be visible or not
    createDisabled: { type: Boolean, default: false },

    // Disable updates
    disabled: { type: Boolean, default: false },

    // Should the delete button be visible or not
    deleteDisabled: { type: Boolean, default: false },
  },

  asyncComputed: {
    isAdmin() {
      return this.isAdminAction();
    },

    /**
     * Checks read rights
     * to see if viewing the entity is allowed.
     */
    async canRead() {
      if (!this.rightsGroup) {
        return false;
      }
      return this.can(this.rightsGroup, 'read');
    },

    /**
     * Checks create rights and createDisabled property
     * to see if creation is allowed.
     */
    async canCreate() {
      if (!this.rightsGroup) {
        return false;
      }
      return this.can(this.rightsGroup, 'create', [!this.createDisabled]);
    },

    /**
     * Checks update rights and disabled property
     * to see if updating is allowed.
     */
    async canUpdate() {
      if (!this.rightsGroup) {
        return false;
      }
      return this.can(this.rightsGroup, 'update', [!this.disabled]);
    },

    /**
     * Checks remove rights and deleteDisabled property
     * to see if removing is allowed.
     */
    async canDelete() {
      if (!this.rightsGroup) {
        return false;
      }
      return this.can(this.rightsGroup, 'delete', [!this.deleteDisabled]);
    },
  },

  computed: {
    ...mapState('auth', ['user']),
  },

  methods: {
    ...mapActions('auth', {
      isAdminAction: 'isAdmin',
      hasRights: 'hasRights',
    }),

    async can(rightsGroup, subjects, otherConditions) {
      return can(rightsGroup, subjects, otherConditions);
    },
  }
};
